import { z } from 'zod/v3';
import { ROW_UNIQUE_KEY_NAME, zSequenceNumber } from '../../../common/utils';
import { zUniqueKey } from '../../../common/utils/schema/zUniqueKey';

const CategoryHierarchyBaseValidFormDataSchema = z.object({
  [ROW_UNIQUE_KEY_NAME]: zUniqueKey(),
  childSequenceNumber: zSequenceNumber(),
  displayName: z.string(),
});

export type CategoryHierarchyValidFormDataType = z.infer<
  typeof CategoryHierarchyBaseValidFormDataSchema
> & {
  children: CategoryHierarchyValidFormDataType[];
};

export const CategoryHierarchyValidFormDataSchema: z.ZodType<CategoryHierarchyValidFormDataType> =
  CategoryHierarchyBaseValidFormDataSchema.extend({
    children: z.lazy(() => z.array(CategoryHierarchyValidFormDataSchema)),
  });
